import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'เมนูหลัก',
    isTitle: true,
  },
  {
    label: 'แผงบริหาร',
    icon: 'home',
    link: '/dashboard',
  },
  {
    label: 'จัดการระบบงาน',
    icon: 'folder',
    link: '/application',
  },
  {
    label: 'จัดการสิทธิ์การเข้าถึงระบบ',
    icon: 'user',
    link: '/user',
  },
];
